<template>
  <div id='footer'>
    <p v-if="!iniFrame">Copyright &#169; by Indiana State University</p>
    <ul>
      <li><a href="#" @click.prevent="openSubmit()">Submit a trip</a></li>
      <li><a href="#" @click.prevent="openCon()">Contact Us</a></li>
    </ul>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
export default {
  data () {
    return {
      iniFrame: true
    }
  },
  mounted () {
    if (window !== window.top) {
      this.iniFrame = true
    } else {
      this.iniFrame = false
    }
  },
  computed: {
    ...mapState({
      filters: state => state.filters,
      active: state => state.subPanelActive,
      contactActive: state => state.contactActive,
      rightActive: state => state.rightPanelActive
    })
  },
  methods: {
    ...mapActions({
      openSubPanel: 'openSubPanel',
      openContact: 'openContact',
      closeRightPanel: 'closeRightPanel',
      closeSubPanel: 'closeSubPanel',
      closeContact: 'closeContact'
    }),
    openSubmit: function (active, contactActive, rightActive) {
      this.openSubPanel()
      if (this.contactActive) {
        this.closeContact()
      }
      if (this.rightActive) {
        this.closeRightPanel()
      }
    },
    openCon: function (active, contactActive, rightActive) {
      this.openContact()
      if (this.active) {
        this.closeSubPanel()
      }
      if (this.rightActive) {
        this.closeRightPanel()
      }
    }
  }
}
</script>
<style scoped>
  #footer {
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    width: 100%;
    padding:.5em 1.5em;
    position: absolute;
    z-index: 9999;
    background-color: #043969;
    font-size:.875em;
    color:#fff;
    box-sizing:border-box;
  }
  #footer p {
    float:left;
  }
  #footer ul {
    float:right;
  }
  #footer ul li {
    list-style-type:none;
    display:inline-block;
  }
  #footer ul li a:link, #footer ul li a:visited {
    display:block;
    color:#fff;
    text-decoration:none;
    margin:0 .75em;
  }
  #footer ul li a:hover, #footer ul li a:active {
    text-decoration:underline;
  }

  @media (max-width : 769px) {

  }

  @media (max-width : 769px) and (orientation: portrait) {
    #footer {
      font-size:.75em;
    }
    #footer p {
      float:none;
      margin:.5em 0 .75em 0;
      text-align:center;
    }
    #footer ul {
      float:none;
      margin:0;
      text-align:center;
      padding:0;
    }
    #footer ul li {

    }
  }

  @media (max-width : 769px) and (orientation: landscape) {
    #footer {
      height:35px;
    }
    #footer p, #footer ul {
      margin:.25em 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?18a6c4e4